import { defineNuxtPlugin } from "nuxt/app"

// plugins/globals.client.js
export default defineNuxtPlugin((nuxtApp) => {
  const myGlobals = {
    mainLogo: '/logos/M.Mobility-logo-SQ.png',
    sideBarLogo: '/logos/M.Mobility-logo-SQ-W.png',
    defaultDomain: true,
    backgroundImage: '/images/M.Mobility-logo-SQ-W.png'
  }

  if (process.client) {
    switch (window.location.hostname) {
      case 'inicio.succes.mobiin.pt':
      case 'inicio.succes.staging.mobiin.pt':
      case 'inicio.succes.localhost':
        myGlobals.mainLogo = '/logos/succes.png'
        myGlobals.sideBarLogo = '/logos/succes.png'
        myGlobals.defaultDomain = false
        myGlobals.backgroundImage = '/images/login_banner_succes.png'
        break
      default:
        myGlobals.mainLogo = '/logos/M.Mobility-logo-SQ.png'
    }
  }

  // Inject into Nuxt app
  nuxtApp.provide('globals', myGlobals)
})
